<template>

  <v-container fluid>
    
    <!-- LSM 발송리스트 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_payment" @keydown.esc="dialog_payment = false" max-width="800px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('eventinvit_label1')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog_payment = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-data-table
                :headers="payment_headers"
                :items="paymentItem"
                :no-data-text="$t('common_nodata')"
                hide-default-footer
                class="datatablestyle"
                item-key="IDX"
                >
                <template v-slot:header.messageId>
                  <label class="cheader_normal" >{{$t("eventinvit_col11")}}</label>
                </template>
                <template v-slot:header.requestTime>
                  <label class="cheader_normal" >{{$t("eventinvit_col12")}}</label>
                </template>
                <template v-slot:header.to>
                  <label class="cheader_normal" >{{$t("eventinvit_col13")}}</label>
                </template>
                                                

                <template v-slot:item.messageId="{ item }">  
                  <a @click="getMessageInfo(item.messageId)" >{{item.messageId}}</a>
                </template>
              </v-data-table>              
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="dialog_payment = false">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>            

    <!-- 상세 메시지 정보 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_print" @keydown.esc="dialog_print = false" max-width="800px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('eventinvit_label2')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog_print = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <vue-json-pretty
                :data="iamData"                  
                >
              </vue-json-pretty>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="dialog_print = false">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>    
    

    <!-- 참가자 정보 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_user" @keydown.esc="dialog_user = false" max-width="500px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('common_userinfo_label1')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog_user = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense> 
                <v-text-field v-model="visitorItem.IDX" :label="$t('eul_col2')" disabled></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="visitorItem.COM_NAME" :label="$t('common_userinfo_label2')" disabled></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="visitorItem.EVENT_NAME" :label="$t('common_userinfo_label3')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                  <v-text-field :value="$i18n.locale === 'ko' ? visitorItem.OPTION_NAME : visitorItem.OPTION_NAME_ENG" :label="$t('common_userinfo_label4')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                <v-text-field v-model="visitorItem.REGTYPE_NAME" :label="$t('common_userinfo_label18')" disabled></v-text-field>
              </v-row>

              <!-- 행사별 커스텀 기본정보 -->              
              <template v-for="item in infoItem">
                <template v-if="item.USETYPE == 1">
                  <template v-if="item.LANTYPE == 4">
                    <v-row dense :key="item.INPUT_CODE">
                      <label style="color:rgba(0,0,0,0.38)">{{item.NAME}}</label>
                    </v-row>
                    <template v-if="visitorItem['INFO'+item.INPUT_CODE] != null && visitorItem['INFO'+item.INPUT_CODE] != undefined && visitorItem['INFO'+item.INPUT_CODE].length > 1">
                      <v-row dense :key="item.INPUT_CODE" justify="center">
                        <img  :height="item.HEIGHT" :width="item.WIDTH" :src="visitorItem['INFO'+item.INPUT_CODE]" class="image"/>
                      </v-row>
                    </template>
                    <template v-else>
                      <v-row dense :key="item.INPUT_CODE" justify="center">
                        <label style="color:rgba(0,0,0,0.38)">{{$t('common_userinfo_label5')}}</label>
                      </v-row>
                    </template>
                  </template>

                  <template v-else-if="item.LANTYPE == 5">
                    <v-row dense :key="item.INPUT_CODE">
                      <label style="color:rgba(0,0,0,0.38)">{{item.NAME}}</label>
                    </v-row>
                    <template v-if="visitorItem['INFO'+item.INPUT_CODE] != null && visitorItem['INFO'+item.INPUT_CODE] != undefined && visitorItem['INFO'+item.INPUT_CODE].length > 1">
                      <v-row dense :key="item.INPUT_CODE" justify="center">
                        <a :href="visitorItem['INFO'+item.INPUT_CODE]" download target="_blink">File Download</a>
                      </v-row>
                    </template>
                    <template v-else>
                      <v-row dense :key="item.INPUT_CODE" justify="center">
                        <label style="color:rgba(0,0,0,0.38)">{{$t('common_userinfo_label19')}}</label>
                      </v-row>
                    </template>
                  </template>

                  <template v-else>
                    <template v-if="item.MAXLINES == 1">
                      <v-row dense  :key="item.INPUT_CODE">
                        <v-textarea dense no-resize outlined height="70"
                        v-if="item.USETYPE == 1" v-model="visitorItem['INFO'+item.INPUT_CODE]" :label="item.NAME" disabled></v-textarea>
                      </v-row>
                    </template>
                    <template v-else>
                      <v-row dense  :key="item.INPUT_CODE">
                        <v-text-field v-if="item.USETYPE == 1" v-model="visitorItem['INFO'+item.INPUT_CODE]" :label="item.NAME" disabled></v-text-field>
                      </v-row>
                    </template>
                  </template>
                </template>
              </template>

              <v-row dense>
                  <v-text-field v-model="visitorItem.TEL" :label="$t('common_userinfo_label6')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                  <v-text-field v-model="visitorItem.PRINT_NUMBER" :label="$t('common_userinfo_label8')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                  <v-text-field v-model="visitorItem.SEX_NAME" :label="$t('common_userinfo_label9')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                  <v-text-field v-model="visitorItem.YEAR" :label="$t('common_userinfo_label10')" counter="4" :suffix="$t('common_userinfo_label13')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                  <v-text-field v-model="visitorItem.NAMEKOR" :label="$t('common_userinfo_label12')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                  <v-text-field v-model="visitorItem.STATE_NAME" :label="$t('common_userinfo_label13')" disabled></v-text-field>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="dialog_user = false">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <!-- 행사정보 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_event" @keydown.esc="dialog_event = false" max-width="500px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('common_eventinfo_label1')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog_event = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense>
                  <v-text-field v-model="eventItem.COM_NAME" :label="$t('common_userinfo_label2')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                  <v-text-field v-model="eventItem.NAME" :label="$t('common_userinfo_label3')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                <v-col md="6" sm="12" xs="12">
                  <v-text-field v-model="eventItem.EVENT_START" :label="$t('common_eventinfo_label2')" disabled></v-text-field>
                </v-col>
                <v-col md="6" sm="12" xs="12">
                  <v-text-field v-model="eventItem.EVENT_END" :label="$t('common_eventinfo_label3')" disabled></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" sm="12" xs="12">
                  <v-text-field dense v-model="eventItem.STATE_NAME" :label="$t('common_userinfo_label13')" disabled></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" sm="12" xs="12">
                  <v-text-field dense v-model="eventItem.TYPENAME" :label="$t('common_eventinfo_label4')" disabled></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="dialog_event = false">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>   
    </v-row>    

    <!-- 입장료 옵션정보 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_option" @keydown.esc="dialog_option = false" max-width="500px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('eventinvit_label3')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog_option = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense>
                  <v-text-field :value="$i18n.locale === 'ko' ? odItem.NAME : odItem.NAME_ENG" :label="$t('common_userinfo_label4')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                <v-col md="6" sm="12" xs="12">
                  <v-text-field v-model="odItem.REG_START" :label="$t('common_eventoption_label1')" disabled></v-text-field>
                </v-col>
                <v-col md="6" sm="12" xs="12">
                  <v-text-field v-model="odItem.REG_END" :label="$t('common_eventoption_label2')" disabled></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" sm="12" xs="12">
                  <v-text-field dense v-model="odItem.STATE_NAME" :label="$t('common_userinfo_label13')" disabled></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" sm="12" xs="12">
                  <v-text-field dense v-model="odItem.COST_TYPE" :label="$t('common_eventoption_label3')" disabled></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field dense v-model="odItem.COST" :label="$t('common_eventoption_label4')" disabled></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field dense v-model="odItem.COST_USD" :label="$t('common_eventoption_label5')" disabled></v-text-field>
                </v-col>
              </v-row>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="dialog_option = false">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>   
    </v-row>        

    <!-- 발송 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" max-width="600px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{ dialogTitle }}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense> 
                <v-text-field v-model="editedItem.COM_NAME" :label="$t('eventinvit_label15')" disabled></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="editedItem.EVENT_NAME" :label="$t('eventinvit_label16')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                  <v-select dense v-model="editedItem.OPTION_IDX" :items="optionItem" :label="$t('eventinvit_label4')" 
                    :item-text="$i18n.locale === 'ko' ? 'NAME' : 'NAME_ENG'" item-value="IDX"
                    />
              </v-row>

              <v-row dense>
                  <v-text-field :rules="[v => Number.isInteger(Number(v)) || $t('common_numberrules')]" v-model="editedItem.TEL" :label="$t('eventinvit_label5')"></v-text-field>
              </v-row>

              <v-row dense>
                  <v-textarea counter="150" color="#4e6ef7" v-model="MSG1" :label="$t('eventinvit_label7')" value="" outlined :rules="[ v => (v.length <= 150) || this.$t('eventinvit_label8') ]" ></v-textarea>
              </v-row>
              <v-row dense>
                  <v-textarea counter="200" color="#4e6ef7" v-model="MSG2" :label="$t('eventinvit_label9')" value="" outlined :rules="[ v => (v.length <= 200) || this.$t('eventinvit_label10') ]" ></v-textarea>
              </v-row>
              <v-row dense>
                  <v-textarea counter="150" color="#4e6ef7" v-model="MSG3" :label="$t('eventinvit_label11')" value="" outlined :rules="[ v => (v.length <= 150) || this.$t('eventinvit_label12') ]" ></v-textarea>
              </v-row>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large  @click="close">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large  @click="save">{{$t('eventinvit_label13')}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>
    
    <!-- 엑셀등록 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="excel_dialog" @keydown.esc="excel_dialog = false" max-width="600px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('eventinvit_label14')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="excel_dialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense> 
                <v-text-field  v-model="SEARCH_COM_NAME" :label="$t('eventinvit_label15')" disabled></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="SEARCH_EVENT_NAME" :label="$t('eventinvit_label16')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                  <v-select dense v-model="excelItem.OPTION_IDX" :items="optionItem" 
                    :label="$t('eventinvit_label4')" 
                    :item-text="$i18n.locale === 'ko' ? 'NAME' : 'NAME_ENG'" item-value="IDX"/>
              </v-row>

              <v-row dense>
                  <v-textarea counter="150" color="#4e6ef7" v-model="MSG1" :label="$t('eventinvit_label7')" value="" outlined :rules="[ v => (v.length <= 150) || this.$t('eventinvit_label8') ]" ></v-textarea>
              </v-row>

              <v-row dense>
                  <v-textarea counter="200" color="#4e6ef7" v-model="MSG2" :label="$t('eventinvit_label9')" value="" outlined :rules="[ v => (v.length <= 200) || this.$t('eventinvit_label10') ]" ></v-textarea>
              </v-row>

              <v-row dense>
                  <v-textarea counter="150" color="#4e6ef7" v-model="MSG3" :label="$t('eventinvit_label11')" value="" outlined :rules="[ v => (v.length <= 150) || this.$t('eventinvit_label12') ]" ></v-textarea>
              </v-row>

              <v-row dense>
                <v-file-input
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" 
                  :label="$t('eventinvit_label17')" v-model="uploadFile" dense></v-file-input>
              </v-row>
              <v-row>
                <v-progress-linear :indeterminate="excel_prog"/>
              </v-row>
              <v-row justify="center" class="mt-5">
                <v-btn rounded color="primary" @click="uploadExcel()">{{$t('eventinvit_label18')}}</v-btn>  
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
              <v-btn class="dialog_cancel_btn" rounded large @click="excel_dialog = false">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <v-row align="center" dense>
      <v-col cols="12">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
    </v-row>

    <v-row no-gutters dense justify="end" align="center">
      <template v-if="grade >= 50">
        <v-col cols="12" md="2" sm="12" xs="12" class="pa-0">
          <comdialog  :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
        </v-col>
      </template>
      <v-col cols="12" md="2" sm="12" xs="12" class="pa-0">
        <eventdialog  :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
      </v-col>
      
      <v-col cols="12" md="2" sm="12" xs="12" class="pa-0">
        <v-text-field 
          dense single-line clearable
          @keyup.enter="search_run" 
          v-model="search_keyword" 
          :placeholder="$t('common_search_holder')"
          outlined height="43"
          color="#808080"
          hide-details
          />
      </v-col>
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn style="width:94%" class="search_btn_freesize" outlined large @click="search_run">{{$t("common_search")}}</v-btn>
      </v-col>
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="width:94%"
            :data-my-variable="$i18n.locale === 'ko' ? 'true' : 'false'"
             class="blue_btn_freesize" elevation="0" outlined large @click="newinsert">{{$t('eventinvit_label19')}}</v-btn>
          </template>
          <span>{{$t('eventinvit_label20')}}</span>
        </v-tooltip>
      </v-col>        
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">        
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="width:94%" 
            :data-my-variable="$i18n.locale === 'ko' ? 'true' : 'false'"
            class="yellow_btn_freesize" elevation="0" outlined large @click="newexcelinsert()">{{$t('eventinvit_label21')}}</v-btn>
          </template>
          <span>{{$t('eventinvit_label22')}}</span>
        </v-tooltip>
      </v-col>        
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">        
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="downloadExcel()">{{$t('eventinvit_label23')}}</v-btn>
          </template>
          <span>{{$t('eventinvit_label24')}}</span>
        </v-tooltip>
      </v-col>
  </v-row>

  <v-row dense no-gutters>
    <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label>
  </v-row>

  <v-row align="start">
    <v-col>
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        
        class="datatablestyle"
        :items-per-page="pagerow"
        :search="search"  
        item-key="IDX"
        :loading="loading"
        >

        
        
        <template v-slot:header.EVENT_NAME>
          <a :class="sort_name=='EVENT_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('EVENT_NAME')">{{$t("eventinvit_col2")}}</a>
        </template>
        <template v-slot:header.OPTION_NAME>
          <a :class="sort_name=='OPTION_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('OPTION_NAME')">{{$t("eventinvit_col3")}}</a>
        </template>
        <template v-slot:header.PHONE>
          <label class="cheader_normal" >{{$t("eventinvit_col4")}}</label>
        </template>
        <template v-slot:header.REQDATE>
          <a :class="sort_name=='REQDATE'?'cheader_sortselect':'cheader_sort'" @click="customsort('SENDDATE')">{{$t("eventinvit_col9")}}</a>
        </template>
        <template v-slot:header.printlist>
          <label class="cheader_normal" >{{$t("eventinvit_col10")}}</label>
        </template>
        
        <template v-slot:item.USER_IDX="{ item }">  
          <template v-if="item.USER_IDX == null">
            <td>{{$t('common_member2')}}</td>
          </template>
          <template v-else>
            <td>{{$t('common_member')}}</td>
          </template>
        </template>
        <template v-slot:item.EVENT_NAME="{ item }">  
          <a @click="loadevent(item.EVENT_IDX)" >{{item.EVENT_NAME}}</a>
        </template>
        <template v-slot:item.OPTION_NAME="{ item }">  
          <a @click="loadoption(item.EVENT_IDX, item.OPTION_IDX)" >{{ $i18n.locale === 'ko' ? item.OPTION_NAME : item.OPTION_NAME_ENG}}</a>
        </template>
        <template v-slot:item.INFO1="{ item }">  
          <a @click="loadvisitor(item.VISITOR_IDX, item.EVENT_IDX)" >{{item.INFO1}}</a>
        </template>
        <template v-slot:item.printlist="{ item }">  
            <v-icon small @click="getReqinfo(item.REQUESTID, item.REQDATE)">mdi-link</v-icon>
        </template>     
      </v-data-table>
    </v-col>
  </v-row>

  <!-- 하단 페이징 영역 -->
  <v-row align="start">
    <v-col cols="12" md="1"/>
    <v-col cols="12" md="2">
      <v-text-field
        v-model="search"
        append-icon="search"
        :label="$t('common_filter')"
        single-line
        hide-details
        outlined height="43"
        color="#808080"
        dense
        />
    </v-col>
    <v-col cols="12" md="6" class="d-flex justify-center">
      <v-btn v-if="bottompage > 10" style="font-size:16px" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
      <span v-for="n in subpage" :key="n.id">
          <span v-if="page == bottompage-1+n">
              <v-btn style="font-size:16px" color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
          <span v-else>
              <v-btn class="font-size:16px" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
      </span>
      <v-btn v-if="subpage == 10" style="font-size:16px" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-select
        v-model="pagerow"
        :items="pagerow_combo"
        item-text="NAME"      
        item-value="VALUE"
        :label="$t('common_rownum')"
        min-width="150px"
        outlined height="43"
        color="#808080"
        dense
        ></v-select>
    </v-col>
    <v-col cols="12" md="1"/>
  </v-row>


  </v-container>
</template>

<script>
//import dateFormat from 'dateformat'
import dateFormat from 'dateformat'
import moment from 'moment'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
import XLSX from 'xlsx'
export default {

    components:{
      VueJsonPretty
    },

    data: () => ({
      //파일 업로드
      uploadFile : null,

      //필수 페이징 파라메터
      totalcnt : 0,       //전체 아이템 개수
      page : 0,
      maxpage : 0,        //전체 페이지 개수
      startpage : 1,      //시작 인덱스
      bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
      subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '발송하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      defaultItem: {
          PHONE:null,
          USER_IDX:null,
          COM_IDX:null,
          COM_NAME:'',
          EVENT_IDX:null,
          EVENT_NAME:'',
      },
      editedItem: {
      },

      iamData:{},
      MSG1:'',  //초대인사
      MSG2:'',  //행사정보
      MSG3:'',  //주의사항

      //엑셀처리
      excelItem: {},
      excel_dialog: false,
      excel_prog: false,

      infoItem:[],    //행사별 기본접수양식 커스텀 정보
      optionItem:[],  //행사별 옵션정보

      //테이블 정의
      headers: [
        {text: '행사명', value: 'EVENT_NAME', sortable: false, align:'center' },
        {text: '등록 카테고리', value: 'OPTION_NAME', sortable: false, align:'center' },
        {text: '수신전화번호',  value: 'PHONE', sortable: false, align:'center' },
        {text: '발송일시',    value: 'REQDATE', sortable: false, align:'center' },
        {text: '발송정보',  value: 'printlist', sortable: false, align:'center'},
      ],
      itemList: [],

      //LSM발송 리스트정보
      paymentItem:[],
      dialog_payment:false,
      payment_headers: [
        {text: '메시지번호', value: 'messageId', sortable: true, align:'center'},
        {text: '발송일시', value: 'requestTime', sortable: true, align:'center' },
        {text: '수신번호', value: 'to', sortable: true, align:'center'},
      ],

      sort_name: 'SENDDATE',
      sort_type: true,    //true : DESC, false: ASC

      search_keyword : '',
      search: '',         //필터링용 검색어

      //한 페이지 ROW 개수 설정
      pagerow : 20,       //한 페이지에 보여줄 row수
      pagerow_combo : [
          {NAME:'20', VALUE:20}
        , {NAME:'50', VALUE:50}
        , {NAME:'100', VALUE:100}
        , {NAME:'200', VALUE:200}
      ],    

      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      grade : 0,

      dialog_user:false,
      dialog_event:false,
      dialog_option:false,
      dialog_print:false,
      visitorItem: {},
      eventItem: {},
      odItem: {},

    }),

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");
      
      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    create(){

    },

    methods: {
      
      newexcelinsert(){
        this.uploadFile = null;
        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

        //행사정보 가져오기
        this.edit_item2();

      },      

      downloadExcel(){
        this.$confirm(this.$t('eventinvit_msg2')).then(() => {

            var templist = [];
            for(var i=0;i<1000;i++){
              templist.push({"A":"", "B":""});
            }            

            var item_sheet = XLSX.utils.json_to_sheet(templist);

            //상단 컬럼명 수정
            item_sheet.A1 = {v:this.$t('eventinvit_msg3')};
            item_sheet.B1 = {v:this.$t('eventinvit_msg4')};

            //컬럼별 너비
            var wscols = [{wch:15},{wch:15}];
            item_sheet['!cols'] = wscols;

            //전화번호 타입 처리
            for(var j=0;j<1000;j++){
                var cell_ref1 = item_sheet[XLSX.utils.encode_cell({c:0, r:j})];
                cell_ref1.t = 's';
                cell_ref1.z = '@';
            }

            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, item_sheet, this.$t('eventinvit_msg33'));
            XLSX.writeFile(wb, this.SEARCH_EVENT_NAME+this.$t('eventinvit_msg34'));

        });
      },

      getColumnName(item){
        var temp = "";
        if(item.USETYPE == 0){
          temp = this.$t('eventinvit_msg7');
          return temp;
        }else{
          temp = item.NAME;
        }
        if(item.REQTYPE == 1){
          temp += this.$t('eventinvit_msg8');
        }
        if(item.LANTYPE == 2){
          temp += this.$t('eventinvit_msg9');
        }
        return temp;
      },

      uploadExcel(){

        if(this.excelItem.OPTION_IDX == null || this.excelItem.OPTION_IDX == undefined){
          this.$alert(this.$t('eventinvit_msg10'));
          return;
        }
        
        if(this.MSG2  == undefined || this.MSG2.length < 1){
          this.$alert(this.$t('eventinvit_msg11'));
          return;
        } 

        if(this.uploadFile == null){
          this.$alert(this.$t('eventinvit_msg12'));
          return;
        }
        this.$confirm(this.$t('eventinvit_msg13')).then(() => {
          
          this.excel_prog = true;
          const reader = new FileReader();
          const numberval = /[^0-9]/g;

          reader.onload = ()=>{
            var fileData = reader.result;
            let workbook = XLSX.read(fileData, {type : 'binary'});  
            var sheetNameList = workbook.SheetNames; // 시트 이름 목록 가져오기 
            var firstSheetName = sheetNameList[0]; // 첫번째 시트명            
            var firstSheet = workbook.Sheets[firstSheetName]; // 첫번째 시트 
            let wrokjson = XLSX.utils.sheet_to_json(firstSheet, {defval:""});

            if(wrokjson.length > 1000){
              this.$alert(this.$t('eventinvit_msg14'));
              return;
            }

            //빈값 제거 (1000줄을 채워놔서 빈값 빼야함)
            var checkflag = true;
            var uploaditem = [];
            wrokjson.forEach(element=>{
              var nullcnt = 0;
              if(element[this.$t('eventinvit_msg3')] == null || String(element[this.$t('eventinvit_msg3')]).length < 1){
                nullcnt++;
              }
              if(element[this.$t('eventinvit_msg4')] == null || String(element[this.$t('eventinvit_msg4')]).length < 1){
                nullcnt++;
              }
              //비교 - 전부다 값이 비어있으면 무시하고 값이 입력된 경우에만 업로드 대상
              if(nullcnt != 2){
                uploaditem.push(element);
              }
            })

            for(var i=0;i<uploaditem.length;i++){
              if(!checkflag){
                break;
              }
              var element = uploaditem[i];
              
              if(element[this.$t('eventinvit_msg3')] == null || String(element[this.$t('eventinvit_msg3')]).length < 1){
                this.$alert(i+1+this.$t('eventinvit_msg15'));
                checkflag = false;
                break;
              }
              
              if(numberval.test(element[this.$t('eventinvit_msg3')])){
                this.$alert(i+1+this.$t('eventinvit_msg16'));
                checkflag = false;
                break;
              }
              
            }

            if(!checkflag){
              this.excel_prog = false;
              this.excel_dialog = false;
              return;
            }

            //서버로 전송해서 처리
            this.$http.post(this.$host+'/api/SMSUpload',{
                JSONVALUE: escape(JSON.stringify(uploaditem))
              , MSG1: this.MSG1 == undefined || this.MSG1.length < 1 ? "" : escape(this.MSG1)
              , MSG2: escape(this.MSG2)
              , MSG3: this.MSG3 == undefined || this.MSG3.length < 1 ? "" : escape(this.MSG3)
              , EVENTNAME: escape(this.SEARCH_EVENT_NAME)
              , COM_IDX: this.excelItem.COM_IDX
              , OPTION_IDX: this.excelItem.OPTION_IDX
              , EVENT_IDX: this.excelItem.EVENT_IDX
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , TEL_COLUMN: this.$t("eventinvit_msg3")
              , LAN_CODE:this.$i18n.locale
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
            .then((result)=>{
              this.excel_prog   = false;
              this.excel_dialog = false;
              if(result.data.resultCode == 0){
                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                if(result.data.resultData.length > 0){
                  this.$alert(result.data.resultData.length+this.$t('eventinvit_msg17')).then(()=>{
                    this.page = 0;
                    this.loadpage(1);
                  });
                }else{
                  this.$alert(this.$t('eventinvit_msg18')).then(()=>{
                    this.page = 0;
                    this.loadpage(1);
                  });
                }

              }else if(result.data.resultCode == 2){
                //로그인 필요
                this.$alert(this.$t("common_tokener"));
                this.$session.clear("ADMIN_IDX");
                this.$session.clear("COM_IDX");
                this.$session.clear("ACNT_IDX");
                this.$session.clear("GRADE");
                this.$session.clear("COM_NAME");
                this.$session.clear("ACCESSTOKEN");
                this.$session.clear("REFLASHTOKEN");
                this.$router.push('Login');   //로그인 페이지로 이동

              }else{
                this.$alert(this.$t("common_insert_fail"));
              }
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error)=>{
              this.excel_prog   = false;
              this.excel_dialog = false;
              this.$alert(this.$t("common_insert_fail"));
            });

          }

          reader.readAsBinaryString(this.uploadFile);  //비동기로 파일을 읽어서

        });


      },

      customsort(sortname){
        this.sort_name = sortname;
        this.sort_type = !this.sort_type;
        this.loadpage(this.page);
      },

      prev(){
          this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
          this.loadpage(temp_page);
      },
      next(){
          this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage;
          this.loadpage(temp_page);
      },

      makepaging(){
        var div1 = this.totalcnt / this.pagerow; 
        var div2 = this.totalcnt % this.pagerow;
        if(div2 == 0){  
            this.maxpage = parseInt(div1);    
        }else{
            this.maxpage = parseInt(div1+1);
        }
        if(this.bottompage == 1){
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        }
      },

      loadpage(p){
        
        this.itemList.splice(0, this.itemList.length);   //데이터 초기화
        
        if(this.grade < 99){
          if(this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_tcom'));
            return;
          }
        }

          this.loading = true;
          this.page = p;

          this.$http.post(this.$host+'/api/SmsList',{
                search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
              , sort_name:this.sort_name
              , sort_type: this.sort_type==true ? "DESC" : "ASC" 
              , page: this.page
              , pagerow: this.pagerow
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , EVENT_IDX: this.SEARCH_EVENT_IDX
              , COM_IDX: this.SEARCH_COM_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                this.totalcnt = result.data.totalcnt;
                this.makepaging();
                const list = result.data.resultData;
                list.forEach(element => {
                    this.itemList.push(element); 
                });
                this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){

        this.getEventOption();

        //첫페이지 로드
        this.loadpage(1);
      },      

      //다이얼로그 닫기
      close () {
        this.dialog     = false
        this.dialog_pw  = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      //추가 저장
      save () {

        
        if(this.editedItem.OPTION_IDX  == undefined || this.editedItem.OPTION_IDX.length < 1){
          this.$alert(this.$t('eventinvit_msg19'));
          return;
        } 
        if(this.editedItem.TEL  == undefined || this.editedItem.TEL.length < 1){
          this.$alert(this.$t('eventinvit_msg20'));
          return;
        } 
        const numberval = /^[0-9]/g;
        if(!numberval.test(this.editedItem.TEL)){
          this.$alert(this.$t('eventinvit_msg21'));
          return;
        } 
        if(this.MSG2  == undefined || this.MSG2.length < 1){
          this.$alert(this.$t('eventinvit_msg11'));
          return;
        } 

        //신규
        this.loading = true;
        this.$http.post(this.$host+'/api/SMSInsert',{
              COM_IDX: this.editedItem.COM_IDX
            , TEL: this.editedItem.TEL
            , EVENT_IDX: this.editedItem.EVENT_IDX
            , OPTION_IDX: this.editedItem.OPTION_IDX
            , EVENTNAME: escape(this.SEARCH_EVENT_NAME)
            , MSG1: this.MSG1 == undefined || this.MSG1.length < 1 ? "" : escape(this.MSG1)
            , MSG2: escape(this.MSG2)
            , MSG3: this.MSG3 == undefined || this.MSG3.length < 1 ? "" : escape(this.MSG3)
            , ADMIN_IDX:this.$session.get("ADMIN_IDX")
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          this.loading = false;
          if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t('eventinvit_msg23')).then(()=>{
                const p = this.page;
                this.page = 0;
                this.loadpage(p);
              });
    

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }else{
            this.$alert(this.$t('eventinvit_msg24'));
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading = false;
          this.$alert(this.$t('eventinvit_msg24'));
        });

        this.close()
        
      },      

      //검색
      search_run(){

        this.loadpage(1);

      },
      
      //신규 추가
      newinsert(){

        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

        //행사정보 가져오기
        this.edit_item();

      },

      edit_item(){

        this.$http.post(this.$host+'/api/EventPageDetail',{
              EVENT_IDX: this.SEARCH_EVENT_IDX
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            const list = result.data.resultData;
            if(list[0].DESC1 == null || list[0].DESC1 == undefined){
              this.$alert(this.$t('eventinvit_msg25'));
            }else{
              
              //행사 초대문구 만들기
              var eventinfo = list[0];
              var ANAME2 = "";
              if(eventinfo.AREANAME != null){
                ANAME2 = eventinfo.ADDR1;
              }else{
                if(eventinfo.ADDR1 != null){
                  ANAME2 = eventinfo.ADDR1;
                }
              }
              if(eventinfo.ADDR2 != null){
                ANAME2 += " "+eventinfo.ADDR2
              }
              
              this.MSG2 = this.$t('eventinvit_msg26') + eventinfo.NAME + 
                          this.$t('eventinvit_msg27') + eventinfo.SDAYNAME+this.getDayName(eventinfo.SDAYCODE)+"~"+eventinfo.EDAYNAME+this.getDayName(eventinfo.EDAYCODE) + 
                          this.$t('eventinvit_msg28') + ANAME2;

              this.dialogTitle = this.$t('eventinvit_msg32');
              this.editedIndex  = -1;
              this.editedItem = Object.assign({}, this.defaultItem)

              this.editedItem.COM_IDX     = this.SEARCH_COM_IDX;
              this.editedItem.COM_NAME    = this.SEARCH_COM_NAME;
              this.editedItem.EVENT_IDX   = this.SEARCH_EVENT_IDX;
              this.editedItem.EVENT_NAME  = this.SEARCH_EVENT_NAME

              this.dialog = true;
            }
              

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading = false;
        });

      },      

      edit_item2(){

        this.$http.post(this.$host+'/api/EventPageDetail',{
              EVENT_IDX: this.SEARCH_EVENT_IDX
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            const list = result.data.resultData;
            if(list[0].DESC1 == null || list[0].DESC1 == undefined){
              this.$alert(this.$t('eventinvit_msg25'));
            }else{
              
              //행사 초대문구 만들기
              var eventinfo = list[0];
              var ANAME = "";
              if(eventinfo.AREANAME != null){
                ANAME = eventinfo.ADDR1;
              }else{
                if(eventinfo.ADDR1 != null){
                  ANAME = eventinfo.ADDR1;
                }
              }
              if(eventinfo.ADDR2 != null){
                ANAME += " "+eventinfo.ADDR2
              }

              this.MSG2 = this.$t('eventinvit_msg26') + eventinfo.NAME + 
                          this.$t('eventinvit_msg27') + eventinfo.SDAYNAME+this.getDayName(eventinfo.SDAYCODE)+"~"+eventinfo.EDAYNAME+this.getDayName(eventinfo.EDAYCODE) + 
                          this.$t('eventinvit_msg28') + ANAME;

              this.excelItem = Object.assign({}, this.defaultItem)
              this.excelItem.COM_IDX     = this.SEARCH_COM_IDX;
              this.excelItem.COM_NAME    = this.SEARCH_COM_NAME;
              this.excelItem.EVENT_IDX   = this.SEARCH_EVENT_IDX;
              this.excelItem.EVENT_NAME  = this.SEARCH_EVENT_NAME
              this.excel_dialog = true;

            }
              

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading = false;
        });

      },      


      //결제내역 확인
      payment_item(item){
        this.$alert(item);
      },

      //업체선택 콜백
      comdialogcb(val){
        if(val.NAME.length > 0){
          this.editedItem.COM_NAME = val.NAME;
          this.editedItem.COM_IDX  = val.IDX;
        }else{
          this.$alert(this.$t('common_select_company'));
          return;
        }
      },

      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
          this.$session.set("COM_IDX", val1.IDX);
          this.$session.set("COM_NAME", val1.NAME);
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }
        this.loadpage(1);
      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
          this.getEventOption();
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.infoItem.splice(0, this.infoItem.length);   //데이터 초기화
        }
        this.loadpage(1);
      },

      priceToString(price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },

      //행사별 행사옵션 가져오기
      getEventOption(){

        this.optionItem.splice(0, this.optionItem.length);   //데이터 초기화
        
        if(this.SEARCH_COM_IDX == null){
            return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          return;
        }

        this.$http.post(this.$host+'/api/EventOptionList',{
              COMIDX: this.SEARCH_COM_IDX
            , EVENT_IDX: this.SEARCH_EVENT_IDX
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              const list = result.data.resultData;
              list.forEach(element => {
                if(element.STATE == 1){
                  this.optionItem.push(element); 
                }
              });
          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading = false;
          if(error.message == 'Request failed with status code 429')
          {
            this.$alert(this.$t("common_reqer"));
          }else{
            this.$alert(error.message);
          }
        });        

      },


      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX    = null;
          this.SEARCH_COM_NAME   = '';
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.search_run();
      },


      loadevent(eidx){

          this.$http.post(this.$host+'/api/EventDetail',{
                ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , EVENT_IDX: eidx
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                const list = result.data.resultData;
                this.eventItem = list[0];
                this.dialog_event = true;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            
          });

      },

      loadoption(eidx, oidx){

          this.$http.post(this.$host+'/api/EventOptionDetail',{
                ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , EVENT_IDX: eidx
              , OPTION_IDX: oidx
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                const list = result.data.resultData;
                this.odItem = list[0];
                this.dialog_option = true;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            
          });

      },      

      loadvisitor(vidx, eidx){

          this.$http.post(this.$host+'/api/VisitorDetail',{
                ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , EVENT_IDX: eidx
              , VISITOR_IDX: vidx
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                const list = result.data.resultData;
                this.visitorItem = list[0];
                this.dialog_user = true;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            
          });

      },      

      //발송내역 확인
      getReqinfo(reqid, date){

        
        let startdate = moment(date, "YYYY-MM-DD HH:mm:ss");
        startdate.add(-1, 'days');
        let enddate = moment(date, "YYYY-MM-DD HH:mm:ss");
        enddate.add(7, 'days');
        

          this.$http.post(this.$host+'/api/LSMRequestList',{
                ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , REQID: reqid
              , STARTDATE: dateFormat(startdate, "yyyy-mm-dd HH:MM:ss")
              , ENDDATE: dateFormat(enddate, "yyyy-mm-dd HH:MM:ss")
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){
                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                const list = result.data.resultData;
                this.paymentItem.splice(0, this.paymentItem.length);
                list.forEach(element => {
                    this.paymentItem.push(element); 
                });
                this.dialog_payment = true;
            }else{
              this.$alert(this.$t('eventinvit_msg30'));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            
          });

      },      

      //메시지정보 확인
      getMessageInfo(mid){

          this.$http.post(this.$host+'/api/LSMMessageInfo',{
                ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , MESSAGEID: mid
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){
              this.iamData = result.data.resultData
              this.dialog_print = true;
            }else{
              this.$alert(this.$t('eventinvit_msg30'));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            
          });

      },      

      getDayName(daycode){
        var dayname = "";
        if(daycode == 0){
          dayname = this.$t('common_day1');
        }else if(daycode == 1){
          dayname = this.$t('common_day2');
        }else if(daycode == 2){
          dayname = this.$t('common_day3');
        }else if(daycode == 3){
          dayname = this.$t('common_day4');
        }else if(daycode == 4){
          dayname = this.$t('common_day5');
        }else if(daycode == 5){
          dayname = this.$t('common_day6');
        }else if(daycode == 6){
          dayname = this.$t('common_day7');
        }
        return dayname;
      },

    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

</style>